<template>
  <section
    id="layout"
    class="l-contentmain contentmain"
    :class="'layout-' + $route.name">
    <router-view></router-view>
    <transition
      enter-active-class="animated fadeIn fast"
      leave-active-class="animated fadeOut fasterx2"
      mode="out-in">
      <div
        v-if="overlayVisible"
        class="contentmain-overlay"
        :class="{'is-visible': overlayVisible}"
        @click="overlayToogle(false); overlayCloseEmitEvent()"></div>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'Layout',
  data: function () {
    return {
      overlayVisible: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    /**
      * is admin dashboard
      * @return {boolean}
      */
    isAdminDashboard () {
      return this.$route.name === 'Home' && this.isAdmin && !this.$route.query.map
    },
    /**
      * as max Height
      * @return {boolean}
      */
    maxHeight () {
      return 'maxHeight' in this.$route.meta && this.$route.meta.maxHeight === true
    }
  },
  mounted () {
    bus.$on(EVENTS.OPEN_CONTENTMAIN_OVERLAY, () => { this.overlayToogle(true) })
    bus.$on(EVENTS.CLOSE_CONTENTMAIN_OVERLAY, () => { this.overlayToogle(false) })
  },
  methods: {
    /**
      * overlay toogle
      * @param {boolean} - etat
      */
    overlayToogle (etat = null) {
      if (etat === null) this.overlayVisible = !this.overlayVisible
      else this.overlayVisible = etat
    },
    /**
      * emit close overlay toogle
      */
    overlayCloseEmitEvent () {
      bus.$emit(EVENTS.CLOSE_CONTENTMAIN_OVERLAY)
    }
  }
}
</script>
